import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from "jquery";

// import Swiper JS
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);
// import Swiper styles
import 'swiper/css';

import "./slider/swipers.js"
import "./sections/header.js";
import "./blocks/imageboxes.js";
import "./modules/latestnews.js";
import "./modules/howwework.js";
import "./modules/products.js";
import "./cards/cardswiper.js";

/**
  Global js
*/

$(document).ready(function() {

  $('.footer-backtotop').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, 1000);
  });

});



